import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchMenu = async () => {
  const { data } = await axios.get(`${API}/menu`);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await axios.post(`${API}/orders`, payload);
  return data;
};

export const getCloverConfig = async () => {
  const { data } = await axios.get(`${API}/payments/clover-config`);
  return data;
};

export const chargeOrderWithClover = async (orderId, source) => {
  const { data } = await axios.post(`${API}/orders/${orderId}/charge-clover`, { source });
  return data;
};
